import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;

  @media (max-width: 1422px) {
    flex-wrap: wrap;
  }
`
export const Label = styled.span`
  font-weight: 600;
  color: var(--color-night);
`
export const Value = styled.span`
  color: var(--color-night);
  margin-right: 16px;
`
export const Parameter = styled.div`
  font-size: 14px;
  line-height: 20px;
`
